import { ConfigProvider, Tabs, TabsProps } from "antd"

import variables from "@/_styles/variables.module.scss"

const theme = {
  components: {
    Tabs: {
      cardBg: variables.baseBgColorLight,
      itemHoverColor: variables.secondBasecolor,
      itemSelectedColor: variables.secondBasecolor,
      itemActiveColor: variables.secondBasecolor
    }
  }
}

export const CustomTabs = (props: TabsProps) => { 
    return (
        <>
            <ConfigProvider theme={theme}>
                <Tabs {...props} className="customTab" destroyInactiveTabPane={false}>
                    {props.children}
                </Tabs>
                <style>
                    {`
                        .customTab {
                            /* Кнопки вкладок */
                            .ant-tabs-tab-btn { 
                                padding: 3px;
                            }
                        }

                        /* Внешний вид активной вкладки */
                        .customTab .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
                            font-weight: 600;
                        }
                    `}
                </style>
            </ConfigProvider>
        </>
    )
}